import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=7c659227&scoped=true&"
import script from "./SidebarHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarHeader.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=7c659227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c659227",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c659227')) {
      api.createRecord('7c659227', component.options)
    } else {
      api.reload('7c659227', component.options)
    }
    module.hot.accept("./SidebarHeader.vue?vue&type=template&id=7c659227&scoped=true&", function () {
      api.rerender('7c659227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/components/Sidebar/SidebarHeader.vue"
export default component.exports